import { Box } from '@chakra-ui/react';
import React from 'react';

import type { ContractAbiItemInput } from '../types';

import { useI18n } from 'lib/i18n/context';

import { ADDRESS_CONTRACT_KEYS } from '../../../i18n';
import { CONTRACT_METHOD_FIELD_LABEL_WIDTH, useContractMethodFieldStyles } from './contractMethodFieldStyles';
import { getFieldLabel } from './utils';

interface Props {
  data: ContractAbiItemInput;
  isOptional?: boolean;
  level: number;
  w?: string | { base: string; md: string };
}

const ContractMethodFieldLabel = ({ data, isOptional, level, w }: Props) => {
  const { t } = useI18n();
  const styles = useContractMethodFieldStyles();

  return (
    <Box
      w={ w ?? (level === 0 ? CONTRACT_METHOD_FIELD_LABEL_WIDTH : '250px') }
      fontSize={ level === 0 ? '14px' : 'sm' }
      lineHeight={ level === 0 ? '24px' : 5 }
      py={ level === 0 ? 0 : '6px' }
      flexShrink={ 0 }
      fontWeight={ 500 }
      color={ styles.labelColor }
    >
      { getFieldLabel(data, !isOptional, t(ADDRESS_CONTRACT_KEYS.methods.unnamedArgument)) }
    </Box>
  );
};

export default React.memo(ContractMethodFieldLabel);
